import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    root: {},
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    groupContainer: {
      padding: theme.spacing(2),
    },
    cards: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
      gap: theme.spacing(1.5),
    },
    title: {
      marginBottom: theme.spacing(1.5),
    },
    // A card fills its column up to its full width, so a narrow list keeps three columns.
    card: {
      width: '100%',
      maxWidth: 138,
      minHeight: 168,
    },
    newCard: {
      marginBottom: theme.spacing(3), // display empty space where the "brand voice" part of the regular card should be
    },
    presetDescription: {
      whiteSpace: 'pre-line',
    },
  }),
  { name: 'ImageStyleList' }
);
